import React, { useState } from "react";
import { Link } from "react-router-dom";
import cn from "classnames";
import OutsideClickHandler from "react-outside-click-handler";
import styles from "./Messages.module.sass";
import Icon from "../../Icon";
import Actions from "../../Actions";
import Item from "./Item";
import { useUser } from "../../../context";
import brand_text from "../../../i11/brand";

const Messages = ({ className }) => {
	const [visible, setVisible] = useState(false);
	const { locale, setLocal } = useUser();
	const messages = [
		{
			title: "Interational",
			content: "English",
			check: locale === "en",
			language: "en",
		},
		{
			title: "Italiano",
			content: "Italy",
			check: locale === "it",
			language: "it",
		},
	];
	return (
		<OutsideClickHandler onOutsideClick={() => setVisible(false)}>
			<div
				className={cn(styles.messages, className, {
					[styles.active]: visible,
				})}
			>
				<button
					className={cn(styles.head)}
					onClick={() => setVisible(!visible)}
				>
					<Icon reicon="lang" size="24" />
				</button>
				<div className={styles.body}>
					<div className={styles.top}>
						<div className={styles.title}>{brand_text[locale].lang}</div>
						{/* <Actions
							className={styles.actions}
							classActionsHead={styles.actionsHead}
							items={actions}
							small
						/> */}
					</div>
					<div className={styles.list}>
						{messages.map((x, index) => (
							<Item
								className={cn(styles.item, className)}
								item={x}
								key={"eleme_" + index}
								onClose={() => {
									setLocal(x.language);
									setVisible(false);
								}}
							/>
						))}
					</div>
					{/* <Link
						className={cn("button", styles.button)}
						to="/message-center"
						onClick={() => setVisible(false)}
					>
						View in message center
					</Link> */}
				</div>
			</div>
		</OutsideClickHandler>
	);
};

export default Messages;
